import * as React from "react";
import { SVGProps } from "react";
export const PersonOffFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="1em"
        viewBox="0 -960 960 960"
        width="1em"
        fill="currentColor"
        {...props}
    >
        <path d="m743-116-77-76H264.09q-29.74 0-50.91-21.15Q192-234.3 192-264v-20q0-25.78 12.5-47.39T239-366q43-26 91-42t99-21L115-743q-11-10.67-10.5-25.33Q105-783 116-794q11-11 25.67-11 14.66 0 25.33 11l626.92 627.92Q805-155 805-140.82q0 14.18-11 24.82-10.67 11-25.33 11Q754-105 743-116Zm-21-250q20 11 32 30t14 42l-99-99q13.63 6.3 26.88 12.6 13.25 6.3 26.12 14.4ZM559-504 360-703q20-31 52-48t68-17q60 0 102 42t42 102q0 36-17 68t-48 52Z" />
    </svg>
);
PersonOffFillIcon.displayName = "PersonOffFillIcon";
